import { dataGiftSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGiftSolid = /*#__PURE__*/createIcon(dataGiftSolid)
export default IconGiftSolid
